type Cleanup = () => void;

class AppEventBus {
  private readonly target = new EventTarget();

  emit(type: string, detail?: unknown) {
    const event = new CustomEvent(type, { detail });
    this.target.dispatchEvent(event);
  }

  on<T = unknown>(type: string, listener: (detail: T) => void): Cleanup {
    const handler = (event: Event) => {
      listener((event as CustomEvent<T>).detail);
    };
    this.target.addEventListener(type, handler);
    return () => {
      this.target.removeEventListener(type, handler);
    };
  }
}

const eventBus = new AppEventBus();

export const emitEvent = (type: string, detail?: unknown) => eventBus.emit(type, detail);

export const addEventListener = <T = unknown>(
  type: string,
  listener: (detail: T) => void
): Cleanup => eventBus.on(type, listener);
